import { ToolbarState } from "../../../types/models/store";

const initState = {
  selected_tracks: [],
  added_status: "",
};

const ReduxState = (state: ToolbarState = initState, action: any) => {
  switch (action.type) {
    case "SET_SELECTED_TRACKS":
      return { ...state, selected_tracks: action.payload };
    case "SET_ADDED_STATUS":
      return { ...state, added_status: action.payload };
    default:
      return { ...state };
  }
};

export default ReduxState;
